import { Typography } from "@material-ui/core";
import moment from "moment";
import React from "react";
import { useIntl } from "react-intl";
import { useCongress } from "../../hooks";

const ThankYou = () => {
  const intl = useIntl();

  const { congress } = useCongress();

  return (
    <Typography variant="body1" align="center">
      <strong>
        {intl.formatMessage(
          {
            id: "Auth.ThankYou.ThankYou",
            defaultMessage: "Thank you for visiting {name}."
          },
          congress
        )}
      </strong>
      <br />
      {intl.formatMessage(
        {
          id: "Auth.ThankYou.EventEnded",
          defaultMessage: "The event ended on {endDate}."
        },
        { endDate: moment(congress.endAt).format("DD/MM/YYYY") }
      )}
      <br />
      {intl.formatMessage({
        id: "Auth.ThankYou.ContentUnavailable",
        defaultMessage: "All contents are no more available."
      })}
    </Typography>
  );
};

export default ThankYou;
